/* NB-017-AB */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.what-to-expect-timeline--var-1');
  if (!root) return;

  const pushEvent = (event, extra) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event, task_id: 'NB-017-AB' }, extra || {}));
  };

  const cta = root.querySelector('[data-nb017-cta]');
  if (cta) {
    cta.addEventListener('click', () => {
      pushEvent('nb017_cta_click', { cta_location: 'timeline' });
    });
  }

  if (!('IntersectionObserver' in window)) return;

  let visibleSent = false;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || visibleSent) return;
        visibleSent = true;
        pushEvent('nb017_timeline_visible');
        observer.disconnect();
      });
    },
    { threshold: 0.5 }
  );

  observer.observe(root);
});
